import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';

import RequestInput from './RequestInput';

const tooltipText =
  'Credentials store your verification details for easy authentication.';

export const RequestAuthenticationQueryParamType = w.TypeImplementation.Alias({
  type: w.withMeta({placeholder: 'E.g. api-token'}, wast.TText),
  render: function RenderRequestAuthenticationQueryParam({expr, dispatch}) {
    return (
      <RequestInput
        label="Query parameter"
        tooltipText={tooltipText}
        expr={expr}
        dispatch={dispatch}
        required
      />
    );
  },
});
